import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';
import { PlayerDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';
import ListWithTotal from 'common/dto-types/list-with-total-dto';

export const getPlayers = async (params: PaginationAndFiltersParams): Promise<ListWithTotal<PlayerDto>> => {
    try {
        const res = await axiosServices.get<ListWithTotal<PlayerDto>>(
            `${InsideFifaBackOfficeEndpoints.Players}${buildQueryParams(params)}`,
        );

        return res.data;
    } catch (err) {
        throw err;
    }
};
